import { NgClass } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { fuseAnimations } from '@fuse/animations';
import dayjs from 'dayjs';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { Subject, takeUntil } from 'rxjs';
import ShortcutButtonsPlugin from 'shortcut-buttons-flatpickr';

@Component({
  selector: 'time-period-select',
  templateUrl: './time-period-select.component.html',
  styleUrls: ['./time-period-select.component.scss'],
  animations: fuseAnimations,
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatOptionModule,
    MatInputModule,
    MatDatepickerModule,
    NgClass,
  ],
})
export class TimePeriodSelectComponent implements OnInit, OnDestroy, OnChanges {
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  formControl = new UntypedFormControl(1);
  form: UntypedFormGroup;
  constructor(private formBuilder: UntypedFormBuilder) {
    this.spanish = Spanish;
  }

  get fromDateForm() {
    return this.form?.get('fromDate')!;
  }
  get toDateForm() {
    return this.form?.get('toDate')!;
  }
  spanish: any;

  maxToDate: Date = dayjs().add(30, 'year').toDate();
  minToDate: Date = dayjs().add(-30, 'year').toDate();
  maxFromDate: Date = dayjs().add(30, 'year').toDate();
  minFromDate: Date = dayjs().add(-30, 'year').toDate();

  options: any[] = [
    {
      id: 1,
      text: 'Desde el comienzo',
    },
    {
      id: 2,
      text: 'Últimos 24 meses',
    },
    {
      id: 3,
      text: 'Últimos 12 meses',
    },
    {
      id: 4,
      text: 'Últimos 3 meses',
    },
    {
      id: 5,
      text: 'Último mes',
    },
    {
      id: 6,
      text: 'Año actual',
    },
  ];
  @Input() initialDate: string | undefined;
  @Input() initialValue?: number = 1;
  @Input() allowCustomRange?: boolean = false;
  @Output() valueChange = new EventEmitter<{
    value: number;
    dateFrom: string;
    dateTo: string;
    initialDate?: string;
    labels?: string[];
  }>();

  plugingsCalendar = [
    ShortcutButtonsPlugin({
      button: {
        label: 'Limpiar',
      },
      onClick: (index: any, fp: any) => {
        fp.clear();
        fp.close();
      },
    }),
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.form) {
      const now = dayjs().toDate();
      // let now_last_year = dayjs(now).subtract(1,'year');
      this.form = this.formBuilder.group({
        fromDate: [''],
        toDate: [now],
      });
      // console.log(now)
      this.maxToDate = now;
      this.maxFromDate = now;
    }

    this.formControl.setValue(changes.initialValue.currentValue ?? 1, { emitEvent: false });
  }
  ngOnInit() {
    if (this.allowCustomRange) {
      this.options.push({
        id: 7,
        text: 'Personalizado',
      });
    }

    if (!this.form) {
      const now = dayjs().toDate();
      // let now_last_year = dayjs(now).subtract(1,'year');
      this.form = this.formBuilder.group({
        fromDate: [''],
        toDate: [now],
      });
      // console.log(now)
      this.maxToDate = now;
      this.maxFromDate = now;
    }

    this.formControl.setValue(this.initialValue ?? 1);
    this.formControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value: number) => {
      let dateFrom;

      switch (value) {
        case 1:
          dateFrom = this.initialDate;
          break;
        case 2:
          dateFrom = dayjs().subtract(2, 'year').format('YYYY-MM-DD');
          break;
        case 3:
          dateFrom = dayjs().subtract(1, 'year').format('YYYY-MM-DD');
          break;
        case 4:
          dateFrom = dayjs().subtract(3, 'month').format('YYYY-MM-DD');
          break;
        case 5:
          dateFrom = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
          break;
        case 6:
          dateFrom = dayjs().startOf('year').format('YYYY-MM-DD');
          break;
        default:
          break;
      }

      this.valueChange.emit({
        value: value,
        dateFrom: dateFrom,
        dateTo: dateFrom,
        initialDate: this.initialDate,
        labels: [this.options.find(x => x.id === value)?.text],
      });
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(true);
    this.unsubscribe$.unsubscribe();
  }
}
